window.dtWorkContract = function () {
  const dt_work_contract = new DataTable('#work-contract-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#work-contract-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#work-contract-datatable', 4); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[1, 'asc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "name" },
      { "data": "is_permanent" },
    ],
    columnDefs: [
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
    },
  });

  dtFinalTouch()
}

 